import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink, faPowerOff, faUser, faPlus, faCog } from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
  library.add(faLink);
  library.add(faUser);
  library.add(faPlus);
  library.add(faPowerOff);
  library.add(faCog);
}

export default initFontAwesome;
